/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Modal } from 'antd';

import { MdErrorOutline } from 'react-icons/md';

import { useSelector } from 'react-redux';
import history from '~/services/history';

import {
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

const ModalPerfilPendente = ({
  dataUltimoPerfilInstituicao,
  perfilInstituicaoPendente,
}) => {
  const [confirmLoading] = useState(false);
  const { roles } = useSelector(state => state.auth);

  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');
  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const handleOk = () => {
    history.push({
      pathname: `/administrador/perfil-do-hospital`,
    });
  };

  return (
    <Modal
      visible={perfilInstituicaoPendente && !ROLE_ADMIN}
      onOk={null}
      confirmLoading={confirmLoading}
      onCancel={null}
      cancelText="Conferir depois"
      centered
      closable={false}
      footer={null}
      width="480px"
    >
      <ModalContainer>
        <ModalHeader>
          <div className="iconModal">
            <span>
              <MdErrorOutline size={30} />
            </span>
          </div>

          <h2>
            Preenchimento do formulário <br />
            de <span> perfil pendente!</span>
          </h2>
        </ModalHeader>
        <div className="ModalBody">
          {ROLE_MANAGER ? (
            <p>
              Uma vez ao ano, é necessário preencher o formulário de perfil para
              seguir utilizando as funcionalidades do sistema. <br />
              {dataUltimoPerfilInstituicao &&
                `Último preenchimento em ${dataUltimoPerfilInstituicao}`}
            </p>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <p>
                É necessário preencher o <span>formulário de perfil</span>.
              </p>
              <p>
                <b>Contate o Gestor do Sistema da sua Instituição.</b>
              </p>
            </div>
          )}
        </div>
      </ModalContainer>
      {ROLE_MANAGER ? (
        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            {confirmLoading ? ' Enviando...' : 'Conferir agora'}
          </ButtonModal>
        </ModalFooter>
      ) : (
        <ModalFooter>
          <ButtonModal
            type="button"
            onClick={() => history.push('/minha-conta')}
          >
            Acessar minha conta
          </ButtonModal>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default ModalPerfilPendente;
